// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__F+ysa","btnOffer":"AddProduct_btnOffer__gS7Gq"};